module.exports = __webpack_public_path__ + "static/media/vrs2.93405f0b.png";